import { checkForDeleteClientDoc } from "../../Client/utils/helper";
import { buyerCustomerDocsContractTypes, conterOfferContractTypes, createOfferContractTypes, isSellingNotExecutedFunc, listingContractTypes } from "../../Common/commondata/commonData";
import { combineBrokersFirmName, formatPhoneNumber } from "../../Common/utils/extraFunctions";
import { getFullNamesFromArray } from "../../DocumentSection/utils/helper";

export const getCategoryDataHandle = ({ notificatonData }) => {
  if (notificatonData) {
    let { type, openFor, offerId, propertyId, _id } = notificatonData || {};
    let category, categoryId, status;
    if (openFor === "BUYER_AGENT") {
      category = "BUYER";
      categoryId = offerId;
      status = type === "OFFER_TERMINATED" ? "TERMINATED" : "";
    } else {
      category = "SELLER";
      categoryId = propertyId ? propertyId : _id;
    }

    return { category, categoryId, status };
  } else {
    return { category: null, categoryId: null, status: null };
  }
};



const mapSigners = (coClient, role) =>
  coClient.signers?.map((signer) => ({
    ...signer,
    corpKey: coClient.key,
    openFor: role,
    isCorp: true,
  })) || [];

export const mapClientsForSendEmail = ({ clients, role, agents }) => {
  const mergedClients = [...(clients ? clients : []), ...(agents ? agents : [])];
  return (
    mergedClients?.map((coClient) => ({
      ...coClient,
      openFor: coClient.isAgent ? coClient.openFor : role,
      isReadOnly: false,
      isAddedByUser: false,
      ...(coClient.isCorp
        ? {
            signers: mapSigners(coClient, role),
            isCorp: true,
          }
        : { isCorp: false }),
    })) || []
  );
};

export const getBuildDataForCustomerdocs = ({ clientDocId, contractType, contractId, currentAgentDetails, delegate, bos, transactionData = {}, item, officeDetails, docSecondItem }) => {
  let BuyerAgents = [],
    SellerAgents = [];
  let Buyers = [];
  let Sellers = [];
  const isBuyerCustomerDoc = buyerCustomerDocsContractTypes.includes(contractType);
  if (isBuyerCustomerDoc) {
    Buyers = item?.isProperty ? transactionData?.Sellers : transactionData?.Buyers;
    BuyerAgents = item?.isProperty ? transactionData?.SellerAgents : transactionData?.BuyerAgents;
  } else {
    Sellers = item?.isProperty ? transactionData?.Sellers : transactionData?.Buyers;
    SellerAgents = item?.isProperty ? transactionData?.SellerAgents : transactionData?.BuyerAgents;
  }

  let buildData = {
    urlData: {
      ...(isBuyerCustomerDoc && Buyers?.length ? { Buyers } : Sellers?.length ? { Sellers } : {}),
      ...(BuyerAgents?.length > 0 ? { BuyerAgents, BuyerBrokersList: getFullNamesFromArray(BuyerAgents), BuyerBrokersFirmList: combineBrokersFirmName(BuyerAgents) } : {}),
      ...(SellerAgents?.length > 0 ? { SellerAgents, SellerBrokersList: getFullNamesFromArray(SellerAgents), SellerBrokersFirmList: combineBrokersFirmName(SellerAgents) } : {}),

      ...(docSecondItem?.contractType === "LCAE" ? { LcaeCheckedListingContract: "ERTBListingContract" } : docSecondItem?.contractType === "LCAES_ERTL" ? { LcaeCheckedListingContract: "ERTLListingContract" } : docSecondItem?.contractType === "LCAES_ETCT" ? { LcaeCheckedListingContract: "ExclusiveTenantListingContract" } : {}),

      ...(docSecondItem?.contractType === "LCAE" ? { LcaeInitatingParty: "LcaeInitatingPartyBuyer" } : docSecondItem?.contractType === "LCAES_ERTL" ? { LcaeInitatingParty: "LcaeInitatingPartyLandlord" } : docSecondItem?.contractType === "LCAES_ETCT" ? { LcaeInitatingParty: "LcaeInitatingPartyTenant" } : {}),
      officeDetails,
      ...(docSecondItem?.contractType ? { ...transactionData } : {}),
    },
    openFor: isBuyerCustomerDoc ? "BUYER_AGENT" : "SELLER_AGENT",
    RTDInitiator: isBuyerCustomerDoc ? "BUYER" : "SELLER",
    ...((delegate || bos) ? { delegateOwnerId: currentAgentDetails?._id } : {}),
    ...(bos && {screenType: "BOS"}),
    ...(docSecondItem?.contractType && clientDocId ? { clientDocId } : {}),
    ...(docSecondItem?.contractType === "LCAES" ? { propertyId: item?.propertyId } : {}),
    openForPropertyDoc: isBuyerCustomerDoc ? "BUYER_AGENT" : "SELLER_AGENT",
    contractId: contractId,
    contractType: contractType,
    token: localStorage.getItem("userAuth"),
    builtForSection: "DOCUMENT",
    builtForId: currentAgentDetails?._id,
    key: currentAgentDetails?._id,
    signable: true,
  };
  return buildData;
};

export const canPropertyDocItemBeDeleted = ({ eachDoc, getCoordinateItem }) => {
  if (!eachDoc || eachDoc?.storageType==="FOLDER") {
    return false;
  }
  if (eachDoc?.isCustomerDoc && !checkForDeleteClientDoc(eachDoc)) {
    return false;
  }
  const isSellingNotExecuted = isSellingNotExecutedFunc({ item: getCoordinateItem });
  if (listingContractTypes.includes(eachDoc?.contractType) && getCoordinateItem?.isProperty && isSellingNotExecuted) {
    return false;
  }
  const isbuyingNotExecuted = getCoordinateItem?.status === "ARCHIVED" || getCoordinateItem?.status === "CLOSED" || getCoordinateItem?.status === "ACCEPTED" || getCoordinateItem?.status === "TERMINATED";
  if (createOfferContractTypes.includes(eachDoc?.contractType) && isbuyingNotExecuted) {
    return false;
  }
  if (conterOfferContractTypes.includes(eachDoc?.contractType) && eachDoc?.buyerSignStatus === "SUBMITTED" && eachDoc?.sellerSignStatus === "SUBMITTED") {
    return false;
  }
  return true;
};

export const hasPropertyDocsMenuItems = ({ eachDoc, getCoordinateItem }) => {
  return eachDoc?.doc_second?.length > 0 || canPropertyDocItemBeDeleted({ eachDoc, getCoordinateItem });
};

export const prepareCurrentAgentDetails = ({ currentAgentDetails = {}, contractType }) => {
  const officeDetails = {
    officeLogo: currentAgentDetails?.brokerageData?.logo || "",
    name: currentAgentDetails?.brokerageData?.name?.trim() || "",
    address: currentAgentDetails?.brokerageData?.address || "",
    agentId: currentAgentDetails?._id,
  };

  const agentArray = [
    {
      personId: currentAgentDetails?._id || null,
      fullName: currentAgentDetails?.fullName || "",
      email: currentAgentDetails?.email || "",
      resureFirmId: currentAgentDetails?.brokerageData?.resureFirmId || "",
      firmName: currentAgentDetails?.brokerageData?.name?.trim() || "",
      firmLicense: currentAgentDetails?.brokerageData?.licenseNumber || "",
      license: currentAgentDetails.licenseId || "",
      address: currentAgentDetails?.brokerageData?.address || "",
      ...(contractType === "DC_ADBA" && { labelType: "DESIGNATED_BROKER" }), 
      phoneNumber: formatPhoneNumber(currentAgentDetails?.mobilePhoneNumber?.phoneNumber || ""),
      officePhoneNumber: formatPhoneNumber(currentAgentDetails?.brokerageData?.phoneNumber || ""),
      faxNumber: formatPhoneNumber(currentAgentDetails?.brokerageData?.faxNumber || "", "FAX"),
    },
  ];

  return { officeDetails, agentArray };
};
